import { applyFormat } from "components/ui/ui-helpers";

export const ApplySignedFormat = (value) => {
  if (Number(value) > 0) {
    return "+ " + applyFormat(value, "int", { thousands: " ", decimal: ",", unit: " €" });
  }
  return applyFormat(value, "int", { thousands: " ", decimal: ",", unit: " €" });
};
